module.exports = __webpack_public_path__ + "img/icons/attachment-upload/success-ce5d291dbc5e20f966ba2fa711657d44.svg";